import React from "react";

import PropTypes from "prop-types";

import Translate from "Components/Translate";

import "./style.scss";

const ManagerInfoButton = ({ name, onShowDetails }) => {
  return (
    <button className="ManagersInfo__button" onClick={onShowDetails}>
      <div className="ManagersInfo__button-person">
        <div className="ManagersInfo__button-person-post">
          <Translate tag="manager-info-name" />
        </div>
        <div className="ManagersInfo__button-person-data">
          <span className="ManagersInfo__button-person-name">{name}</span>
        </div>
      </div>
    </button>
  );
};

ManagerInfoButton.propTypes = {
  name: PropTypes.string.isRequired,
  onShowDetails: PropTypes.func.isRequired,
};

export default ManagerInfoButton;
